import { Box, styled } from '@mui/material'
import React, { ComponentProps } from 'react'

interface ICustomView extends ComponentProps<typeof Box> {
  backColor?:
    | 'default'
    | 'violet'
    | 'lowViolet'
    | 'white'
    | 'darkGray'
    | 'lowOpacityGray'
    | 'positive'
    | 'negative'
    | 'error'
    | 'warning'
    | 'greenDark'
    | 'lightGray'
    | 'blueDark'
    | 'disabled'
}

const SCustomView = styled(Box)`
  &.white {
    background-color: white;
  }
  &.default {
    background-color: transparent;
  }
  &.violet {
    background-color: #dee2f5;
  }
  &.blueDark {
    background-color: #142954;
  }
  &.lowViolet {
    background-color: #dee2f5;
  }
  &.darkGray {
    background-color: #d0d4dd;
  }
  &.lowOpacityGray {
    background-color: #f3f4f6;
  }
  &.positive {
    background-color: #d9f1dc;
  }
  &.negative {
    background-color: #fddbd0;
  }
  &.error {
    background-color: #f64a14;
  }
  &.warning {
    background-color: #ff8b03;
  }
  &.greenDark {
    background-color: #5e6623;
  }
  &.lightGray {
    background-color: #f6f8fd;
  }
  &.disabled {
    background-color: #f5f5f5 !important;
    opacity: 0.6;
  }
`

function CustomView(
  {
    display = 'flex',
    width = '100%',
    backColor = 'default',
    flexDirection = 'column',
    ...rest
  }: ICustomView,
  ref: any
) {
  return (
    <SCustomView
      display={display}
      width={width}
      className={backColor}
      flexDirection={flexDirection}
      ref={ref}
      {...rest}
    >
      {rest.children}
    </SCustomView>
  )
}

export default React.forwardRef(CustomView)
